import useApiQuery from 'shared/hooks/use-api-query';
import {AdditionalGroupProps} from '../types';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import {AdditionalProps} from 'modules/additionals/types';
import {SelectDataProps} from 'shared/types/select-data';

const useAdditionalGroupsSelect = () => {
  const {companyId} = useAccessControls();

  const {data = [], ...rest} = useApiQuery({
    url: '/additional-groups/all',
  });

  return {
    ...rest,
    data: data.map(
      (
        additionalGroup: AdditionalGroupProps & {
          additionals: AdditionalProps[];
        },
      ) => ({
        label: !companyId
          ? `${additionalGroup.name} - ${additionalGroup.company.name}`
          : additionalGroup.name,
        value: additionalGroup.id,
        data: additionalGroup.additionals,
      }),
    ) as SelectDataProps<AdditionalProps[]>[],
  };
};

export default useAdditionalGroupsSelect;
